const redirectUri = `${window.location.origin}/authentication/callback/`
const logoutUrl = '/authentication/logout/'

export { redirectUri, logoutUrl }
